<template>
  <div>
    <div id="body">
      <div class="banner">
        <div class="wrapper">
          <div class="title">
            <h1>商品贸易数据库<sub>Global Merchandise Trade Database</sub></h1>
          </div>
        </div>
      </div>
      <div class="wrapper">
        <el-row :gutter="20">
          <el-col :span="6"
                  style="height: 750px">
            <div class="left-filter">
              <div class="title"
                   @click="leftFilterShow = !leftFilterShow">
                <h4>
                  <img src="~@/assets/images/icon-f-class.png"
                       alt="" />选择指标
                </h4>
                <i v-if="leftFilterShow"
                   class="el-icon-arrow-up"></i><i v-else
                   class="el-icon-arrow-down"></i>
              </div>
              <div class="search">
                <el-input size="mini"
                          placeholder="输入关键字进行过滤"
                          v-model="filterText">
                </el-input>
              </div>
              <div :class="leftFilterShow ? 'content  show-this' : 'content'"
                   v-loading="treeLoading">
                <!-- <el-tree
                  :props="treeProps"
                  :load="loadNode"
                  node-key="code"
                  lazy
                  show-checkbox
                  @check-change="handleCheckChange"
                  ref="tree"
                  :indent="0"
                >
                </el-tree> -->

                <el-tree :props="treeProps"
                         node-key="code"
                         show-checkbox
                         @check-change="handleCheckChange"
                         ref="tree"
                         :indent="0"
                         :data="treeData"
                         :filter-node-method="filterNode">
                </el-tree>
              </div>
            </div>
          </el-col>
          <el-col :span="18"
                  style="height: 700px">
            <div class="search-filter">
              <el-form>
                <el-form-item>
                  <div class="item-block">
                    <span class="inner-label">区域范围：</span>
                    <el-select size="small"
                               v-model="selectRegion">
                      <template v-for="item in districtNames">
                        <el-option :key="item"
                                   :label="item"
                                   :value="item"
                                   v-if="
                            item !== '台湾省' &&
                            item !== '香港特别行政区' &&
                            item !== '澳门特别行政区'
                          "></el-option>
                      </template>
                    </el-select>
                  </div>
                  <div class="item-block">
                    <span class="inner-label">类型：</span>

                    <el-radio-group v-model="jckType">
                      <el-radio label="jinkou">进口</el-radio>
                      <el-radio label="chukou">出口</el-radio>
                      <el-radio label="jinchukou">进出口</el-radio>
                    </el-radio-group>

                  </div>
                  <div class="item-block">
                    <span class="inner-label">币制：</span>

                    <el-radio-group v-model="jckMoney">
                      <el-radio label="rmb">人民币</el-radio>
                      <el-radio label="usd">美元</el-radio>
                    </el-radio-group>

                  </div>
                  <div class="item-block"
                       style="margin-left: 0">
                    <span class="inner-label">时间范围：</span>
                    <el-date-picker size="small"
                                    v-model="selectDate"
                                    type="monthrange"
                                    range-separator="至"
                                    start-placeholder="开始月份"
                                    end-placeholder="结束月份"
                                    format="yyyy年MM月">
                    </el-date-picker>
                  </div>
                  <div class="item-block">
                    <el-button size="small"
                               @click="handleSearch">
                      查询
                    </el-button>
                    <el-button size="small"
                               @click="handleReset">重置</el-button>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="graph-box">
              <div class="type-filter">
                <el-radio-group v-model="graphType"
                                @change="handleGraphTypeChange">
                  <el-radio-button label="1">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type1.png" />
                    <span class="text">原始表格</span>
                  </el-radio-button>
                  <el-radio-button label="2">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type2.png" />
                    <span class="text">地图</span>
                  </el-radio-button>
                  <el-radio-button label="3"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type3.png" />
                    <span class="text">折线图</span>
                  </el-radio-button>
                  <el-radio-button label="4"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type4.png" />
                    <span class="text">柱状图</span>
                  </el-radio-button>
                  <el-radio-button label="5"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type5.png" />
                    <span class="text">条形图</span>
                  </el-radio-button>
                  <el-radio-button label="6"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type6.png" /><span class="text">堆积柱状图</span>
                  </el-radio-button>
                  <el-radio-button label="7"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type7.png" /><span class="text">堆积条形图</span>
                  </el-radio-button>
                  <el-radio-button label="8"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type8.png" /><span class="text">面积图</span>
                  </el-radio-button>
                  <el-radio-button label="9"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type9.png" /><span class="text">环形图</span>
                  </el-radio-button>
                  <el-radio-button label="10"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type10.png" /><span class="text">雷达图</span>
                  </el-radio-button>
                  <el-radio-button label="11"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type11.png" /><span class="text">填充雷达图</span>
                  </el-radio-button>
                  <el-radio-button label="12"
                                   disabled>
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type12.png" /><span class="text">散点图</span>
                  </el-radio-button>
                </el-radio-group>
                <el-button-group>
                  <el-button disabled
                             :class="seriesLableShow ? 'is-active' : ''"
                             @click="
                      () => {
                        this.seriesLableShow = !this.seriesLableShow;
                        this.handleGraphTypeChange();
                      }
                    ">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type13.png" />
                    <span class="text">数值标签</span>
                  </el-button>
                  <el-button disabled
                             :class="legendShow ? 'is-active' : ''"
                             @click="
                      () => {
                        this.legendShow = !this.legendShow;
                        this.handleGraphTypeChange();
                      }
                    ">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type14.png" />
                    <span class="text">图例</span>
                  </el-button>
                </el-button-group>
                <el-button-group>
                  <el-button disabled
                             type="">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type15.png" />
                    <span class="text">收藏</span>
                  </el-button>
                  <el-button @click="handleExport">
                    <img class="icon"
                         src="~@/assets/images/icon-graph-type16.png" />
                    <span class="text">下载</span>
                  </el-button>
                </el-button-group>
              </div>
              <div class="chat-usage"
                   v-if="!showTable">
                <div class="tip">
                  <p>1、在左侧“选择指标”中勾选数据维度；</p>
                  <p>2、在上方选择“区域范围”和“时间范围”，点击查询即可；</p>
                  <p>3、通过点击图表类型，切换数据显示方式，并下载原始数据；</p>
                  <p>4、单次查询最多可以展示数据10000条。</p>
                </div>
                <div class="intro">
                  <div class="intro-title">商品贸易数据库</div>
                  <div class="intro-row intro-row-bg">
                    <div class="intro-row-left">数据来源：</div>
                    <div class="intro-row-right">中华人民共和国海关总署</div>
                  </div>
                  <div class="intro-row">
                    <div class="intro-row-left">数据总量：</div>
                    <div class="intro-row-right">4547万+</div>
                  </div>
                  <div class="intro-row intro-row-bg">
                    <div class="intro-row-left">数据起止时间：</div>
                    <div class="intro-row-right">
                      2022年1月-{{ new Date().getFullYear() - 1 }}年{{
                        new Date().getMonth()
                      }}月
                    </div>
                  </div>
                  <div class="intro-row">
                    <div class="intro-row-left">更新频率：</div>
                    <div class="intro-row-right">每月更新</div>
                  </div>
                  <div class="intro-row intro-row-bg">
                    <div class="intro-row-left">最近更新时间：</div>
                    <div class="intro-row-right">
                      {{ dateFormat(new Date(), "yyyy年MM月") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="graph"
                   v-show="showTable && graphType == '1'"
                   v-loading="tableLoading">
                <el-table :data="tableData"
                          style="width: 100%"
                          v-if="showTable && tableData && tableData.length > 0">
                  <el-table-column prop="month"
                                   label="日期"
                                   width="100"></el-table-column>
                  <el-table-column prop="goodsName"
                                   label="商品名称"></el-table-column>
                  <el-table-column prop="businessPartnerName"
                                   label="贸易伙伴"
                                   width="150"></el-table-column>
                  <el-table-column prop="registrationRegionName"
                                   label="注册地"
                                   width="150"></el-table-column>
                  <el-table-column prop="tradeModeName"
                                   label="贸易方式"></el-table-column>
                  <el-table-column label="第一数量">
                    <template #default="scope">
                      {{ scope.row.firstCount }}
                      {{
                        scope.row.firstCountUnit
                          ? "（" + scope.row.firstCountUnit + "）"
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column label="第二数量">
                    <template #default="scope">
                      {{ scope.row.secondCount }}
                      {{
                        scope.row.secondCountUnit
                          ? "（" + scope.row.secondCountUnit + "）"
                          : ""
                      }}
                    </template>
                  </el-table-column>
                  <el-table-column label="金额">
                    <template #default="scope">
                      {{
                        scope.row.money && scope.row.money === "rmb"
                          ? "￥"
                          : scope.row.money && scope.row.money === "usd"
                          ? "$"
                          : ""
                      }}
                      {{ scope.row.amount }}
                    </template>
                  </el-table-column>
                </el-table>
                <div class="no-data"
                     v-if="showTable && (!tableData || tableData.length === 0)">
                  <div class="tip">
                    <svg t="1626241932884"
                         class="icon"
                         viewBox="0 0 1428 1024"
                         version="1.1"
                         xmlns="http://www.w3.org/2000/svg"
                         p-id="2321"
                         width="60"
                         height="60">
                      <path d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                            p-id="2322"></path>
                      <path d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                            p-id="2323"></path>
                      <path d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                            p-id="2324"></path>
                      <path d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                            p-id="2325"></path>
                      <path d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                            p-id="2326"></path>
                      <path d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                            p-id="2327"></path>
                    </svg>
                    <div class="text">暂无数据</div>
                  </div>
                </div>
              </div>

              <div class="graph"
                   v-loading="mpaLoading"
                   v-show="showTable && graphType == '2'">
                <div id="container"
                     style="width: 100%; height: 100%"></div>
              </div>

              <div class="graph"
                   v-show="graphType != '1' && graphType != '2'"
                   v-loading="tableLoading">
                <div id="graphTypeCharts"
                     style="width: 100%; height: 100%"></div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";
import moment from "moment";
import districts from "@/assets/geoMap/geo/districts.js";
import worldCapitalsCoordinates from "@/assets/geoMap/geo/worldCapitalsCoordinates.js";
import AMapLoader from "@amap/amap-jsapi-loader";
import { exportTongjiDownload } from "../../util/utils";

export default {
  data () {
    return {
      leftFilterShow: false,
      graphShow: ["", ""],
      graphType: "1",

      showTooltip: "",
      topTabs: "t1",
      guidTabs: "t1-g1",
      guidTabsMore: false,

      treeLoading: false,
      treeData: [],
      treeProps: {
        label: "name",
        disabled: (data, node) => {
          return !node.isLeaf;
        },
        isLeaf: "isLeaf",
      },
      valueCodes: [],

      selectRegion: "北京市",
      selectDate: [],
      jckType: "jinkou",
      jckMoney: "rmb",
      jckGoodsName: "",

      records: [],
      yearCodeArray: [],
      dateCategoryData: [],
      tableLoading: false,
      tableData: [],
      cnameTableHead: [],
      cnameTableHeadUnit: [],
      showTable: false,
      seriesLableShow: false,
      legendShow: true,

      map: null,
      loca: null, //地图动画渲染实例对象
      key: "4b04138c130005c228e166162f08c437", // 开发应用的 ID
      mapStyle: "amap://styles/ef94c91b1fe470206ef0b6c2fa041033",
      mapCenterPoint: [116.2317, 39.5427], //北京坐标
      labelLayer: null, //文字图层
      pulseLink: null, //线条层
      scatterLayer: null, //标记动画层
      scatterLayerCenter: null, //中心点样式层
      markfontColor: "#35a5ff", //区域文字颜色
      lineHeadColor: "red", //脉冲头部颜色
      lineTrailColor: "rgba(255, 255,0,0)", //脉冲尾部颜色

      aereData: [],
      districtNames: [],
      mpaLoading: false,

      filterText: "",
    };
  },
  created () {
    this.districtNames = districts.map((i) => i.name);
    this.getTreeList();
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1 && data.isLeaf;
    },
    getTreeList () {
      this.treeLoading = true;
      axiosRequest(
        "/region-data-index/all-tree-list",
        { type: "spmy" },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.treeData = res.data.data;
          }
          this.treeLoading = false;
        })
        .catch(() => {
          this.treeLoading = false;
        });
    },
    handleExport () {
      if (!this.valueCodes || this.valueCodes.length === 0) {
        this.$message({ message: "请选择指标！", type: "warning" });
        return;
      }

      if (!this.selectDate || this.selectDate.length === 0) {
        this.$message({ message: "请选择时间范围！", type: "warning" });
        return;
      }

      let startYearCode = "",
        endYearCode = "";

      if (this.selectDate && this.selectDate.length > 0) {
        startYearCode = this.dateFormat(this.selectDate[0], "yyyyMM");
      }
      if (this.selectDate && this.selectDate.length > 1) {
        endYearCode = this.dateFormat(this.selectDate[1], "yyyyMM");
      }

      let url = `${process.env.VUE_APP_BASE_API}/search/export-jinchukou-data-table-zb`;
      let data = `region=${this.selectRegion}&type=${this.jckType || "jinkou"
        }&money=${this.jckMoney || "rmb"}&goodsNumber=${this.valueCodes[0]
        }&startYearCode=${startYearCode}&endYearCode=${endYearCode}`;
      // let data = `region=${this.selectRegion}&type=${
      //   this.jckType || "jinkou"
      // }&money=${
      //   this.jckMoney || "rmb"
      // }&goodsNumber=73181600&startYearCode=${startYearCode}&endYearCode=${endYearCode}`;

      exportTongjiDownload(url, "商品贸易数据库", data);
    },
    handleGraphTypeChange (val) {
      if (this.graphType === "1" || !this.showTable) {
        return;
      }

      this.tableLoading = true;

      if (this.graphType === "2") {
        this.mapInit();
      }

      this.tableLoading = false;
    },
    async loadNode (node, resolve) {
      let parentId = -1;
      if (node.level === 0) {
        parentId = 0;
      } else if (node.data && node.data.id) {
        parentId = node.data.id;
      }

      let data = [];

      if (parentId > -1) {
        data = await this.getTreeList(parentId, "spmy");
      }

      return resolve(data);
    },
    // async getTreeList(parentId, type) {
    //   let result = [];

    //   await axiosRequest(
    //     "/region-data-index/tree-list",
    //     { parentId: parentId, type: type },
    //     axiosOptions("post", "", "json")
    //   )
    //     .then((res) => {
    //       if (res.data && res.data.code === 200) {
    //         result = res.data.data;
    //       }
    //     })
    //     .catch(() => {});

    //   return result;
    // },
    handleCheckChange (data, checked) {
      if (checked) {
        this.valueCodes = [data.code];
        this.$refs.tree.setCheckedKeys(this.valueCodes, false);
      }

      // this.valueCodes.push(data.code);
      // this.checked = checked;
      // // 该节点未选中的时候
      // for (var i = 0; i <= this.valueCodes.length; i++) {
      //   if (this.checked == false) {
      //     this.valueCodes.splice(this.valueCodes.indexOf(this.i), 1);
      //   }
      // }
    },
    handleSearch () {
      if (!this.valueCodes || this.valueCodes.length === 0) {
        this.$message({ message: "请选择指标！", type: "warning" });
        return;
      }

      if (!this.selectDate || this.selectDate.length === 0) {
        this.$message({ message: "请选择时间范围！", type: "warning" });
        return;
      }

      this.pageIndex = 1;
      this.tableData = [];
      this.records = [];
      this.yearCodeArray = [];
      this.dateCategoryData = [];
      this.cnameTableHead = [];
      this.cnameTableHeadUnit = [];
      this.graphType = "1";
      this.regionDataTableMatch();
    },
    handleReset () {
      this.valueCodes = [];
      this.$refs.tree.setCheckedKeys(this.valueCodes, false);
      this.selectDate = [];
    },
    regionDataTableMatch () {
      this.tableLoading = true;
      this.showTable = true;

      let startYearCode = "",
        endYearCode = "";

      if (this.selectDate && this.selectDate.length > 0) {
        startYearCode = this.dateFormat(this.selectDate[0], "yyyyMM");
      }
      if (this.selectDate && this.selectDate.length > 1) {
        endYearCode = this.dateFormat(this.selectDate[1], "yyyyMM");
      }

      const selectDistricts = districts.find(
        (i) => i.name === this.selectRegion
      );
      if (selectDistricts && selectDistricts.center) {
        this.mapCenterPoint = selectDistricts.center;
      }

      axiosRequest(
        "/search/jinchukou-data-table-zb",
        {
          region: this.selectRegion,
          type: this.jckType || "jinkou",
          money: this.jckMoney || "rmb",
          goodsNumber: this.valueCodes[0], //"73181600",
          startYearCode: startYearCode,
          endYearCode: endYearCode,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res.data && res.data.code === 200) {
            this.tableData = res.data.data.records;

            let tableAereData = [];
            this.tableData.forEach((item) => {
              let year = item.month.substring(0, 4);
              let month = item.month.substring(4);
              let dateStr = year + "年";
              if (month && month !== "00") {
                dateStr += month + "月";
              }
              item.month = dateStr;
              this.dateCategoryData.push(dateStr);

              const coordinates =
                worldCapitalsCoordinates[item.businessPartnerName];
              let aereDataIndex = tableAereData.findIndex(
                (i) => i.areaName === item.businessPartnerName
              );
              if (aereDataIndex < 0 && coordinates && coordinates.length > 0) {
                tableAereData.push({
                  areaName: item.businessPartnerName,
                  coordinates: coordinates,
                });
              }
            });
            this.aereData = tableAereData;
          }
          this.tableLoading = false;
          // this.mapInit();
          //   console.log(this.tableData);
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    dateFormat (cellValue, format) {
      if (!cellValue) return "";
      return moment(cellValue).format(format);
    },

    //初始化地图
    mapInit () {
      this.mpaLoading = true;
      AMapLoader.load({
        key: this.key,
        version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
        plugins: [],
        Loca: {
          version: "2.0.0",
        },
        AMapUI: {
          // 是否加载 AMapUI，缺省不加载
          version: "1.1", // AMapUI 缺省 1.1
          plugins: [], // 需要加载的 AMapUI ui插件
        },
      })
        .then((map) => {
          AMap = map;
          this.map = new AMap.Map("container", {
            viewMode: "3D",
            zoom: 2.5,
            pitch: 46,
            center: this.mapCenterPoint,
            mapStyle: this.mapStyle,
            showBuildingBlock: true, // 显示建筑物
            showLabel: false, // 不显示地名什么的
            dragEnable: true, //是否允许拖拽
            zoomEnable: true, //是否允许缩放
          });
          //全局化数据地图渲染实例对象
          this.loca = new Loca.Container({
            map: this.map,
          });
          // 文字图层初始化
          this.labelLayer = new AMap.LabelsLayer({
            rejectMapMask: true,
            collision: true,
            animation: true,
          });
          this.map.add(this.labelLayer);
          //线条层初始化
          this.pulseLink = new Loca.PulseLinkLayer({
            zooms: [2, 20],
            zIndex: 10,
            visible: true,
            opacity: 1,
            depth: true,
          });
          //标记动画层
          this.scatterLayer = new Loca.ScatterLayer({
            zIndex: 10,
            opacity: 0.8,
            visible: true,
            zooms: [2, 22],
          });
          //中心点层
          this.scatterLayerCenter = new Loca.ScatterLayer({
            zIndex: 10,
            opacity: 0.8,
            visible: true,
            zooms: [2, 22],
          });
          this.SetDataToMap();

          setTimeout(() => {
            this.mpaLoading = false;
          }, 500);
        })
        .catch((e) => {
          this.mpaLoading = false;
          //console.log(e);
        });
    },
    //数据转换为图形添加到地图中
    SetDataToMap () {
      let centerCoord = this.mapCenterPoint; //[116.2317, 39.5427]; //北京坐标
      //所有区域标记渲染
      this.SetlabelLayer(this.aereData);
      //标记中心点
      this.markerCenter(centerCoord);
      //脉冲线渲染
      this.SetpulseLink(this.aereData);

      //执行动画
      this.loca.animate.start();
    },
    //标记中心点添加mark(中心点坐标)
    markerCenter (data) {
      let centerPoint = new Loca.GeoJSONSource({
        data: {
          type: "FeatureCollection",
          features: [
            {
              type: "Feature",
              geometry: {
                type: "Point",
                coordinates: data,
              },
            },
          ],
        },
      });
      this.scatterLayerCenter.setSource(centerPoint);
      //标注中心点样式
      this.scatterLayerCenter.setStyle({
        size: [300000, 300000],
        unit: "meter",
        texture: "https://a.amap.com/Loca/static/static/center-point.png",
      });
      //3D渲染出标注点
      this.loca.add(this.scatterLayerCenter);

      var labelsMarker = new AMap.LabelMarker({
        name: this.selectRegion,
        position: data,
        zooms: [2, 22],
        opacity: 1,
        zIndex: 10,
        text: {
          content: this.selectRegion,
          direction: "bottom",
          offset: [0, -5],
          style: {
            fontSize: 13,
            fontWeight: "normal",
            fillColor: this.markfontColor,
          },
        },
      });
      this.labelLayer.add(labelsMarker);
    },
    //渲染文字图形(区域坐标数据)
    SetlabelLayer (data) {
      this.labelLayer.clear();
      data.forEach((item) => {
        var labelsMarker = new AMap.LabelMarker({
          name: item.areaName,
          position: item.coordinates,
          zooms: [2, 22],
          opacity: 1,
          zIndex: 10,
          text: {
            content: item.areaName,
            direction: "bottom",
            offset: [0, -5],
            style: {
              fontSize: 13,
              fontWeight: "normal",
              fillColor: this.markfontColor,
            },
          },
        });
        this.labelLayer.add(labelsMarker);
      });
      //mark图形动画处理
      var source = this.jsonToGeoObj(data);
      this.scatterLayer.setSource(source);
      this.scatterLayer.setStyle({
        size: [500000, 500000],
        unit: "miter",
        animate: true,
        duration: 1000,
        texture: "https://a.amap.com/Loca/static/static/orange.png",
      });
      this.loca.add(this.scatterLayer);
    },
    //脉冲线处理
    SetpulseLink (data) {
      var stype = 1; //控制方向，默认进口
      switch (this.jckType) {
        case "chukou":
          stype = 0;
          break;
        case "jinchukou":
          stype = 2;
          break;
      }
      var source = this.jsonToGeoLine(data, this.mapCenterPoint, stype);
      // console.log(source)
      this.pulseLink.setSource(source);
      this.pulseLink.setStyle({
        unit: "meter",
        dash: [40000, 0, 40000, 0],
        lineWidth: function () {
          return [20000, 10000];
        },
        height: function (index, feat) {
          return feat.distance / 3 + 10;
        },
        // altitude: 1000,
        //脉冲速度
        smoothSteps: 3000,
        speed: function (index, prop) {
          return 1000 + Math.random() * 200000;
        },
        flowLength: 1000000,
        lineColors: function (index, feat) {
          return ["#42a5f5"];
        },
        // maxHeightScale: 0.3, // 弧顶位置比例
        maxHeightScale: stype == 0 ? 0.3 : 0.7,
        headColor: this.lineHeadColor, //脉冲头部颜色
        trailColor: this.lineTrailColor, //脉冲尾部颜色
      });
      this.loca.add(this.pulseLink);
    },
    //json转换成geoMark对象
    jsonToGeoObj (json) {
      var ArrayList = [];
      json.forEach((item) => {
        let iobj = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: item.coordinates,
          },
        };
        ArrayList.push(iobj);
      });
      var newJSON = {
        type: "FeatureCollection",
        features: ArrayList,
      };
      return new Loca.GeoJSONSource({
        data: newJSON,
      });
    },
    //json转换geoLine对象(type: 0)
    //startPoint:单点区域坐标
    //type:线条方向type=0：1对多  type=1:多对一
    jsonToGeoLine (json, startPoint, stype) {
      var ArrayList = [];
      console.log(json);
      json.forEach((item) => {
        let iobj = {
          type: "Feature",
          geometry: {
            type: "LineString",
            coordinates:
              stype === 0
                ? [startPoint, item.coordinates]
                : [item.coordinates, startPoint],
          },
        };
        ArrayList.push(iobj);

        if (stype === 2) {
          iobj = {
            type: "Feature",
            geometry: {
              type: "LineString",
              coordinates: [startPoint, item.coordinates],
            },
          };
          ArrayList.push(iobj);
        }
      });

      var newJSON = {
        type: "FeatureCollection",
        features: ArrayList,
      };
      return new Loca.GeoJSONSource({
        data: newJSON,
      });
    },
  },
};
</script>

<style>
.amap-logo {
  display: none !important;
  visibility: hidden !important;
}

.amap-copyright {
  display: none !important;
  visibility: hidden !important;
}

.cnames-width {
  width: 90%;
  max-width: 400px;
}
</style>
<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/search.scss";
@import "@/assets/css/statist.scss";

::v-deep .el-tree {
  padding-left: 25px;

  .el-tree-node__content {
    padding-left: 0px !important;
    white-space: normal;
    height: auto;
    padding: 5px 0;

    > label.el-checkbox.is-disabled {
      display: none;
    }
  }

  .el-tree-node {
    position: relative;
    // padding-left: 16px;

    .el-tree-node__children {
      padding-left: 16px;

      .el-tree-node__content {
        padding-left: 0px !important;
        white-space: normal;
        height: auto;
        padding: 5px 0;
      }
    }

    &:last-child:before {
      height: 38px;
    }
    &:before {
      border-left: none;
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
    }
    &:after {
      border-top: none;
      content: "";
      left: -4px;
      position: absolute;
      right: auto;
      border-width: 1px;
    }
  }
}

::v-deep .search-filter {
  .el-range-separator {
    line-height: 38px;
    padding: 0 10px;
  }
}
</style>